import google from '../../assets/google.svg';

/**
 * Google's four-colour G — item 2.
 *
 * ⚠️⚠️ **A BUNDLED `.svg`, NOT INLINE PATHS AND NOT AN ICON-SET GLYPH.** Two rules meet here and
 * they agree. `icon.tsx` is `lucide-react` reached by name — one stroke weight, `currentColor`
 * throughout — and a one-colour outline of somebody else's logo is a worse rendering than none;
 * Google's branding guidelines require the mark in its four colours, undistorted. And the four
 * `fill="#4285F4"`-style literals that the inline version needed are exactly what
 * `no-restricted-syntax` refuses in component code, correctly: *"a literal is a ninth theme that
 * applies to one element"*.
 *
 * ⚠️ **The colours must NOT follow the theme, which is the same reason the file is the right home
 * for them.** A Google mark tinted to match Mocha is no longer the Google mark. In a `.svg` they
 * are artwork rather than a palette decision — the arrangement `provider-logo.tsx` settled for
 * Jira and YouTrack on the same day, for the same reason (D9).
 *
 * ⚠️ **`aria-hidden`, because the button beside it already says *Google*.** Announcing the mark as
 * well would read the word twice.
 */
export function GoogleMark() {
  return <img src={google} alt="" aria-hidden="true" width={15} height={15} />;
}
